import React from "react";

export default function ApplicantPage() {
    return (
        <div>
            Single Applicant Page
        </div>
    )
}